<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-19",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 39,
      nextPage: '/questionnaire/section2/20',
      navigateType: 'CLICK_NEXT',
      content: {
        layout: 'layout_left',
        componentsType: {
          pc: 'longBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/21-Women’s Health.png'),
        mainTitle: 'Have you ever experienced or are experiencing any of the following symptoms?',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'Pain or burning when you urinate',
            },{
              text: 'Frequent urination',
            }
          ],[
            {
              text: 'Urine smells bad or looks milky white/cloudy',
            },{
              text: 'Blood in the urine',
            }
          ],[
            {
              text: 'None of these',
              unique: true
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
